import { createFileRoute, redirect } from '@tanstack/react-router'

import BackofficeContainer from '@/components/pages/backoffice/containers/BackofficeContainer'
import { sidebarItems } from '@/lib/const'
import { buildRouteModules } from '@/lib/rbac'

export const Route = createFileRoute('/_backoffice')({
  beforeLoad: ({ context: { isAuthenticated, profile } }) => {
    const role = profile?.roles?.[0]?.name

    const userModules = profile?.modules || []
    const backofficeRouteModules = buildRouteModules(sidebarItems)

    if (!isAuthenticated) {
      throw redirect({
        to: '/auth/sign-in',
        replace: true,
        search: { error: 'unauthenticated' }
      })
    }

    const userModuleCodes = userModules.map((m: any) => m.code)
    const userPermissions = userModules.flatMap((m: any) =>
      m.permissions.map((p: any) => p.name)
    )

    const hasModule = (moduleCode: string) =>
      userModuleCodes.includes(moduleCode)
    const hasPermission = (permission: string) =>
      userPermissions.includes(permission)

    const rawPath = location.pathname.replace('/_backoffice', '')
    const currentPath = rawPath.split('?')[0]

    // Check if user is trying to access Pengguna routes without super_admin role
    if (currentPath.startsWith('/user/') && role !== 'super_admin') {
      throw redirect({
        to: '/403'
      })
    }

    // Check if user is trying to access Pindah Domisili without BPP role
    if (
      currentPath.startsWith('/ktg-penyuluh/pindah-domisili') &&
      role !== 'admin_bpp'
    ) {
      throw redirect({
        to: '/403'
      })
    }

    const routeConfig =
      backofficeRouteModules[currentPath as keyof typeof backofficeRouteModules]

    if (routeConfig) {
      if (!hasModule(routeConfig.module)) {
        throw redirect({
          to: '/403'
        })
      }

      if (routeConfig.permission && !hasPermission(routeConfig.permission)) {
        throw redirect({
          to: '/403'
        })
      }
    }
  },
  component: BackofficeContainer
})
